export enum WSEmitType {
  OPEN = 'open',
  CLOSE = 'close',
  MESSAGE = 'message',
  ERROR = 'error',
}

export enum WSContextType {
  GEMX = 'GEMX',
}

export enum WSStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}

export type EmitFunc = (name: WSEmitType, data?: any) => void;

export type EmitMessageFunc = (type: string, data?: any) => void;

export type WebsocketOptions = {
  reconnectEnabled?: boolean;
  reconnectInterval?: number;
  keys?: string[];
};

export interface WebSocketBaseData<T = any> {
  Message: string;
  Status: WSStatus;
  Data: T;
}

export interface WebSocketDataChunk<T = any> extends WebSocketBaseData<T> {
  ChunkIndex: number;
  MessageID: string;
  TotalChunks: number;
}

export interface WebSocketResponse<T extends WebSocketBaseData> {
  RequestID: string;
  Received: string;
  Type: string;
  Data: T;
}

export interface WSChunkEntry {
  totalChunks: number;
  chunks: (string | null)[];
}

export interface WebsocketPlugin {
  install: (app: any, options: WebsocketOptions, shopId?: string) => void;
}

export interface WebsocketStore {
  isConnected: boolean;
  sendMessage: (message: string | Blob | BufferSource) => void;
  sendObject: (data: Record<string, any>) => void;
  reconnect: (url: string) => void;
  connect: (url: string) => void;
  disconnect: () => void;
  on: (name: WSEmitType, cb: (ev: MessageEvent) => void) => any;
  removeListener: (key: WSEmitType, cb: (ev: MessageEvent) => void) => void;
  onMessage: <T = any>(type: string, cb: (data: T) => void) => any;
  offMessage: (type: string, cb: (ev: MessageEvent) => void) => void;
  removeMessageListener: <D>(key: string, cb: (data: D) => void) => void;
}
